
/**
 * @member {string[]} darkModeTailwindClasses
 * A list of classes used for tailwinds darkMode feature
 * that uses the 'class' method instead of 'media'.
 * This class list basically just lists all supported tailwind prefixes from
 * all the different repositories for themes and plugins.
 *
 * dark:    ufr-main-theme
 * bl-dark: ufr-block-library
 */
const darkModeTailwindClasses = [ 'dark', 'bl-dark' ];

const localStorageTheme: string | null = localStorage.theme;
const prefersDarkMode: MediaQueryList = window.matchMedia( '(prefers-color-scheme: dark)' );

function updateDarkMode() {
	if ( localStorageTheme === 'dark' || ( ! localStorageTheme && prefersDarkMode.matches ) ) {
		document.documentElement.classList.add( ...darkModeTailwindClasses );
	} else {
		document.documentElement.classList.remove( ...darkModeTailwindClasses );
	}
}

updateDarkMode();

prefersDarkMode.addEventListener( 'change', updateDarkMode );
